import type { ShopMessageKey } from '../../../i18n'
import type { CustomerAreaNavItem } from './customerAreaLayoutTypes'

type TranslateFn = (key: ShopMessageKey, params?: Record<string, string | number>) => string

const resolveSectionLabels = (language: 'it' | 'en') =>
  language === 'it'
    ? {
        orders: 'ORDINI',
        account: 'ACCOUNT',
        support: 'SUPPORTO',
      }
    : {
        orders: 'ORDERS',
        account: 'ACCOUNT',
        support: 'SUPPORT',
      }

export const buildCustomerAreaNavItems = ({
  t,
  toLocalizedPath,
  language = 'en',
  ordersBadge,
  supportBadge,
}: {
  t: TranslateFn
  toLocalizedPath: (path: string) => string
  language?: 'it' | 'en'
  ordersBadge?: string
  supportBadge?: string
}): CustomerAreaNavItem[] => {
  const sectionLabels = resolveSectionLabels(language)

  return [
    {
      id: 'orders',
      label: t('customer.nav.orders'),
      description: t('customer.nav.ordersDescription'),
      href: toLocalizedPath('/dashboard/orders'),
      badge: ordersBadge,
      section: 'orders',
      sectionLabel: sectionLabels.orders,
    },
    {
      id: 'addresses',
      label: t('customer.nav.addresses'),
      description: t('customer.nav.addressesDescription'),
      href: toLocalizedPath('/dashboard/addresses'),
      section: 'account',
      sectionLabel: sectionLabels.account,
    },
    {
      id: 'preferences',
      label: t('customer.nav.preferences'),
      description: t('customer.nav.preferencesDescription'),
      href: toLocalizedPath('/dashboard/preferences'),
      section: 'account',
      sectionLabel: sectionLabels.account,
    },
    {
      id: 'profile',
      label: t('customer.nav.profile'),
      description: t('customer.nav.profileDescription'),
      href: toLocalizedPath('/dashboard/profile'),
      section: 'account',
      sectionLabel: sectionLabels.account,
    },
    {
      id: 'overview',
      label: t('customer.nav.overview'),
      description: t('customer.nav.overviewDescription'),
      href: toLocalizedPath('/dashboard'),
      section: 'account',
      sectionLabel: sectionLabels.account,
    },
    {
      id: 'support',
      label: t('customer.nav.support'),
      description: t('customer.nav.supportDescription'),
      href: toLocalizedPath('/dashboard/support'),
      badge: supportBadge,
      section: 'support',
      sectionLabel: sectionLabels.support,
    },
    {
      id: 'privacy',
      label: t('customer.nav.privacy'),
      description: t('customer.nav.privacyDescription'),
      href: toLocalizedPath('/dashboard/privacy'),
      section: 'support',
      sectionLabel: sectionLabels.support,
    },
  ]
}
